import styled from "styled-components";

export const BillingLinkVerificationPage = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 16px;
`;

export const BillingLinkVerificationCard = styled.div`
  width: min(100%, 480px);
  box-sizing: border-box;
  padding: 32px;
  background: ${({ theme }) => theme.white};
  border-radius: 24px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  display: grid;
  gap: 16px;

  h1,
  p {
    margin: 0;
  }

  h1 {
    font-family: light;
    font-size: 28px;
    line-height: 36px;
  }

  p {
    font-family: light;
    font-size: 16px;
    line-height: 24px;
  }

  > form {
    display: grid;
    gap: 12px;

    > button {
      justify-self: start;
      text-transform: none;
    }
  }

  > button {
    justify-self: start;
    text-transform: none;
  }
`;

export const BillingLinkVerificationFallback = styled.p`
  padding-top: 4px;
`;

export const BillingSupportLink = styled.a`
  color: ${({ theme }) => theme.greenDark};
  font-weight: 700;
`;
